/**
 * Vodorovný posun kolečkem / dvěma prsty nad karusely.
 *
 * PROČ VŮBEC: stejný pohyb prstů má na celém webu dělat totéž. Jenže banner
 * a karusely zpracovává někdo jiný, a každý má opačnou konvenci:
 *
 *   prsty jdou doleva → tažení: obsah jde s prstem  → DALŠÍ položka
 *   prsty jdou doleva → scroll: viewport jde doleva → PŘEDCHOZÍ položka
 *
 * (Proto se kolečkem dolů posouvá stránka dolů, ale tažením dolů nahoru.)
 * Hero rotátor není scroll kontejner, takže jeho gesto obsluhuje JS a jede
 * podle tažení. Karusely scroll kontejnery jsou, takže je posouvá prohlížeč
 * podle scrollování. Tenhle soubor je přebíjí, aby seděly na banner.
 *
 * ⚠️⚠️ NA TOUCHPADU SE PO GESTU NIC NEDOROVNÁVÁ. Karusel zastaví tam, kde ho
 * prsty nechaly, klidně uprostřed karty. Je to vědomé rozhodnutí, ne
 * nedodělek — obě dřívější varianty byly v ruce horší:
 *   1) krokování po kartách (51b6cc4…58a1d23, revert 26189b2) — začátek gesta
 *      se sekal a delší gesto skočilo o hromadu karet naráz;
 *   2) dojezd na nejbližší kartu po gestu (d03f829, 43ca077) — zarovnání
 *      přišlo až za doznívající setrvačností, takže to působilo jako druhý,
 *      oddělený pohyb: „dojede do půlky a pak cukne".
 *
 * ⚠️ A hlavně: mobilní plynulost tímhle směrem NEJDE. Na dotyku vlastní celý
 * fling prohlížeč — zná rychlost prstu při puštění, dopředu si spočítá, kde
 * dojezd skončí, a rovnou ho zakončí na hraně karty; je to jeden souvislý
 * pohyb na kompozitoru. Z touchpadu dostáváme jen doznívající wheel události
 * a nemáme jak zjistit, kdy a kde skončí, takže jakékoli zarovnání může přijít
 * až ZA nimi. Proto se nedělá žádné.
 *
 * ⚠️ Přichytávání se proto vypíná a nechává vypnuté. `scroll-snap-type:
 * mandatory` by každý drobný posun vrátil zpátky na kartu (touchpad posílá
 * desítky delt po pár pixelech) a při zpětném zapnutí by skočil. Vrací se
 * na `touchstart`, aby dotykovým zařízením zůstalo nativní chování i s flingem
 * a přichytáváním — tam do toho nesaháme vůbec.
 *
 * ⚠️ Svislý pohyb si NEBERE — patří stránce.
 *
 * ⚠️ Delegováno na document v capture fázi: karusely se dorenderovávají
 * (filtry kolekcí, doporučené produkty, výsledky hledání), takže vázat
 * posluchač na konkrétní prvky by nové instance minulo.
 *
 * ⚠️ Plynulost nedožene nativní scroll ani teoreticky: přebít směr jde jedině
 * přes `preventDefault`, a tím se posun stěhuje z kompozitoru na hlavní vlákno.
 * Je to cena za sjednocení směru. Zpět k nativnímu chování (a nativní
 * plynulosti, ale i opačnému směru) = smazat tenhle soubor a jeho <script>
 * v layout/theme.liquid. Nic jiného na něm nevisí.
 */
(() => {
  // Drž synchronně se seznamem v assets/base.css (blok o overscroll-behavior).
  const SCROLLERS = [
    '.tk-categories__scroll',
    '.tk-product-carousel__scroll',
    '.tk-rec__list',
    '.tk-upsell__scroll',
    '.tk-compare__scroll',
    '.tk-blog__grid--4',
    '.tk-arch__chips',
    '.tk-main-blog__tags-scroll',
    '.product-tabs__nav',
    '.predictive-search-results__wrapper',
    '.predictive-search-results__wrapper-products',
    '.dialog-thumbnails-list',
    '.slideshow-controls__thumbnails-container',
  ].join(',');

  // Karusely, kterým jsme vypnuli přichytávání. Obyčejný Set stačí, je jich
  // na stránce hrstka a žijí stejně dlouho jako ona.
  const touched = new Set();

  // Dotyk si nechá nativní chování včetně flingu a přichytávání — tam je
  // dorovnání součástí jednoho pohybu a je to přesně to, co chceme.
  addEventListener(
    'touchstart',
    () => {
      for (const el of touched) el.style.removeProperty('scroll-snap-type');
      touched.clear();
    },
    { capture: true, passive: true }
  );

  addEventListener(
    'wheel',
    (e) => {
      // Firefox posílá u kolečka řádky (deltaMode 1), ne pixely.
      const unit = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? innerWidth : 1;
      const dx = e.deltaX * unit;
      if (!dx || Math.abs(dx) < Math.abs(e.deltaY * unit)) return; // svislé patří stránce
      if (!e.cancelable) return;

      let node = e.target;
      if (node && node.nodeType === 3) node = node.parentNode;
      const el = node && node.closest && node.closest(SCROLLERS);
      if (!el) return;

      // Kontejner, který nemá kam jet, si gesto nenárokuje — jinak by nad ním
      // šlo posouvat „naprázdno" a uživatel by nevěděl, proč se nic neděje.
      if (el.scrollWidth - el.clientWidth < 2) return;

      e.preventDefault();

      if (!touched.has(el)) {
        touched.add(el);
        el.style.setProperty('scroll-snap-type', 'none');
      }

      // Mínus = obrácená konvence proti nativnímu scrollu, viz hlavička:
      // tažení obsahu doleva (dx < 0) posouvá karusel vpřed. Žádný práh,
      // žádné zaokrouhlování na karty, žádné dorovnání po gestu — přesně
      // tolik, kolik ujely prsty.
      el.scrollLeft -= dx;
    },
    { passive: false, capture: true }
  );
})();
